import { useEffect, useState } from 'react';
import Header from '../../common/Header/Header';
import './Dashboard.scss';
import { formatDate } from '../../utils/dateHelper/dateHelper';
import Hub from '../../api/controllers/Hub/Hub';
import Error from '../../common/Error/Error';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [user, setUser] = useState();
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const getHub = user => {
    Hub.show(user.currentHubId)
      .then(hub => {
        setUser({ ...user, hubName: hub.name });
      })
      .catch(e => {
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    setUser(storedUser);
    if (storedUser.currentHubId) {
      getHub(storedUser);
    } else {
      setError(
        'You are not currently assigned to a warehouse. Ask a system administrator to set this up',
      );
    }
  }, []);

  return (
    <div className="dashboard">
      <Header hideQR={!user?.currentHubId} rightButton={'logout'} />
      {user?.currentHubId && (
        <>
          <div className="info_bar">
            <b>Goods In / Goods Out</b>
          </div>
          <div className="button_grid">
            <button className="page_button collections" onClick={() => navigate('/collections')}>
              Domestic Collections
            </button>
            <button className="page_button deliveries" onClick={() => navigate('/deliveries')}>
              Domestic Deliveries
            </button>
            <button className="page_button imports" onClick={() => navigate('/imports')}>
              International Imports
            </button>
            <button className="page_button exports" onClick={() => navigate('/exports')}>
              International Exports
            </button>
            <button
              className="page_button subcontracts_in"
              onClick={() => navigate('/subcontracts_in')}
            >
              Subcontracts (goods in)
            </button>
            <button
              className="page_button subcontracts_out"
              onClick={() => navigate('/subcontracts_out')}
            >
              Subcontracts (goods out)
            </button>
          </div>
          <div className="info_bar">
            <b>Warehouse Management</b>
          </div>
          <div className="button_grid">
            <button className="page_button bays" onClick={() => navigate('/bays')}>
              Bays
            </button>
            <button className="page_button jobs" onClick={() => navigate('/jobs')}>
              Jobs
            </button>
            <button className="page_button arrivals" onClick={() => navigate('/arrivals')}>
              Arrivals
            </button>
            <button
              className="page_button missing"
              onClick={() => navigate('/packages/missing_dimensions')}
            >
              Missing Dimensions
            </button>
          </div>
          <div className="info_bar">
            <div className="item">
              <b>User: </b>
              {user?.name}
            </div>
            <div className="item">
              <b>Last Active: </b>
              {formatDate(user?.lastSignInAt)}
            </div>
            <div className="item">
              <b>Hub: </b>
              {user?.hubName}
            </div>
          </div>
        </>
      )}
      {error && (
        <Error
          errorMessages={error}
          type={'info'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's occurred:' : ' occurred:'} `
              : ''
          }
        />
      )}
    </div>
  );
};

export default Dashboard;
